import BongInputPage from "../components/BongInputPage";

export default function GuestPage() {
  return <BongInputPage role="guest" defaultName="Gjest" stateKey="bong_data_guest" />;
}
